// Group VI. 從句：名詞/形容詞/副詞 Clauses: Noun/Relative/Adverbial
// Complete data from "Grammar 90 Groups (GPT5) 5 Examples Each.txt"

export const group6Data = {
  id: "group_6",
  title: {
    tc: "從句：名詞/形容詞/副詞",
    sc: "从句：名词/形容词/副词",
    en: "Clauses: Noun/Relative/Adverbial"
  },
  subtitle: {
    tc: "Clauses: Noun/Relative/Adverbial",
    sc: "Clauses: Noun/Relative/Adverbial",
    en: "Clauses: Noun/Relative/Adverbial"
  },
  icon: "🔗",
  difficulty: "advanced",
  color: "from-green-500 to-green-600",
  topics: [
    {
      id: "noun_clauses_that",
      title: {
        tc: "名詞子句（that 作受詞）",
        sc: "名词子句（that 作受词）",
        en: "Noun Clauses with that"
      },
      description: {
        tc: "學習以 that 引導的名詞子句作為受詞的用法",
        sc: "学习以 that 引导的名词子句作为受词的用法",
        en: "Learn the usage of that-clauses as objects"
      },
      icon: "📝",
      difficulty: "intermediate",
      examples: [
        {
          id: "noun_that_1",
          sentence: "I think that he is right.",
          analysis: "I (S) think (V) <that> [he (S) is (V) right (C)] (O-clause).",
          translation: {
            tc: "我認為他是對的。",
            sc: "我认为他是对的。",
            en: "I think that he is right."
          }
        },
        {
          id: "noun_that_2",
          sentence: "She believes that we can win.",
          analysis: "She (S) believes (V) <that> [we (S) can win (V)] (O-clause).",
          translation: {
            tc: "她相信我們能贏。",
            sc: "她相信我们能赢。",
            en: "She believes that we can win."
          }
        },
        {
          id: "noun_that_3",
          sentence: "They reported that prices had risen.",
          analysis: "They (S) reported (V) <that> [prices (S) had risen (V)].",
          translation: {
            tc: "他們報告說價格上漲了。",
            sc: "他们报告说价格上涨了。",
            en: "They reported that prices had risen."
          }
        },
        {
          id: "noun_that_4",
          sentence: "It's clear that he lied.",
          analysis: "It (S) is (V) clear (C) <that> [he (S) lied (V)] (C-clause).",
          translation: {
            tc: "很明顯他撒謊了。",
            sc: "很明显他撒谎了。",
            en: "It's clear that he lied."
          }
        },
        {
          id: "noun_that_5",
          sentence: "We found that the door was open.",
          analysis: "We (S) found (V) <that> [the door (S) was (V) open (C)].",
          translation: {
            tc: "我們發現門是開著的。",
            sc: "我们发现门是开着的。",
            en: "We found that the door was open."
          }
        }
      ],
      teachingNotes: {
        tc: "要點：that 可省（口語）；在主語位置常保留。",
        sc: "要点：that 可省（口语）；在主语位置常保留。",
        en: "Key points: that can be omitted (colloquial); often retained in subject position."
      }
    }
  ]
};
